import { apiCall } from '@/assets/module/useApiCall'

const state = {
    categoryName: '',
    frequentlyAskedQuestions: '',
    encryptId: ''
};

const getters = {
    getCategoryName: state => {
        return state.categoryName // カテゴリー一覧（JSON）
    },
    getFrequentlyAskedQuestions: state => {
        return state.frequentlyAskedQuestions // FAQリスト（JSON)
    },
    getEncryptedId: state => {
        return state.encryptId
    }
};

const mutations = {
    setCategory:function(state, result) {   
        state.categoryName = result
    },
    setFrequentlyAskedQuestions: function(state, result) {
        state.frequentlyAskedQuestions = result
    },
    setEncryptedId: function(state, result) {
        state.encryptId = result
    }
};

//dev環境
const FUNCTION_NAME = 'fr-ask';

const actions = {
    async getCategory({rootState,commit}, params) {
        return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params)
        .then(response => {
          let result = response
          commit('setCategory', result)
        })
    },
    async getFrequentlyAskedList({rootState,commit}, params) {
        return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params) 
        .then(response => {
            let result = response
            commit('setFrequentlyAskedQuestions', result)
        })
    },
    async getEncryptCategoryId({rootState,commit}, params) {
        return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params) 
        .then(response => {
            let result = response
            commit('setEncryptedId', result)
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};